import React from 'react';
import { FinanceResponseData } from '@upstart/harmony/lib/legos/financingTypes';
import { FeeDropdownType } from '../ricFormTypes';
import { getFinalizedFee, formatCurrency } from '../ricFormUtils';
import { EmissionsFeeItem, LineItem } from '../Components';

const SchemaFeeDropdown = ({
  formElement,
  responseData,
  fetchResponseWithUpdatedData,
}: {
  formElement: FeeDropdownType;
  responseData: FinanceResponseData;
  fetchResponseWithUpdatedData: (data: Partial<FinanceResponseData>) => void;
}) => {
  const { title, subtitle, feeTypes, required } = formElement;

  const fees = feeTypes.map((ft) =>
    getFinalizedFee(responseData?.finalizedFeeList, ft),
  );
  const selectedFee = fees.find((f) => f);
  return (
    <>
      <LineItem
        title={title}
        subtitle={subtitle}
        value={formatCurrency(selectedFee?.value ?? 0)}
      />
      <div className="form-section">
        <EmissionsFeeItem
          fee={selectedFee}
          responseData={responseData}
          onChange={fetchResponseWithUpdatedData}
          required={required}
        />
      </div>
    </>
  );
};

export default SchemaFeeDropdown;
